import type { ChapterItem } from '@app/_proto/Protos/chapters';
import type { NovelItem } from '@app/_proto/Protos/novels';
import ButtonLink from '@app/components/button.link';
import { getNovelPath } from '@app/domains/common/utils/path';
import { HEADER_HEIGHT_DOWN_SM, HEADER_HEIGHT_ONLY_SM, HEADER_HEIGHT_UP_MD } from '@app/domains/header/constants';
import { breakpoints } from '@app/utils/breakpoints';
import { useGenerateImgAttrs } from '@app/utils/utils';
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';

type NoLongerAvailableChapterLockedProps = {
    novel: NovelItem;
    chapter?: ChapterItem;
};

export default function NoLongerAvailableChapterLocked({ novel, chapter }: NoLongerAvailableChapterLockedProps) {
    return (
        <>
            <Helmet defer={false}>
                <meta name="robots" content="noindex, nofollow" />
                <title>Content not available</title>
            </Helmet>
            <div className="flex h-[100%] flex-1 flex-col sm:flex-row items-center justify-center leading-tight text-black dark:text-white">
                <div className='mx-[20px]'>                    
                    <img
                        src="/images/delisted-sad-man.png"
                        alt=""
                        className='w-[140px] sm:w-[291px] h-auto'
                    />
                </div>
                <div className='mx-[20px] text-center sm:text-left'>
                    <div className='text-[24px] sm:text-[36px] font-semibold'>Content not available</div>
                    <div className="mt-[16px] sm:text-[18px]">
                        We apologize but the chapter you have reached is currently unavailable.
                    </div>
                    <div className="mt-[32px]">
                        <ButtonLink to={getNovelPath(novel.slug as string)}>Back to novel</ButtonLink>                    
                    </div>                
                </div>
            </div>
        </>
    );
}

export const StyledImageContainer = css({
    [breakpoints.upMd]: {
        top: `${HEADER_HEIGHT_UP_MD}px`,
        height: `calc(100% - ${HEADER_HEIGHT_UP_MD}px)`,
    },
    [breakpoints.onlySm]: {
        top: `${HEADER_HEIGHT_ONLY_SM}px`,
        height: `calc(100% - ${HEADER_HEIGHT_ONLY_SM}px)`,
    },
    [breakpoints.downSm]: {
        top: `${HEADER_HEIGHT_DOWN_SM}px`,
        height: `calc(100% - ${HEADER_HEIGHT_DOWN_SM}px)`,
    },
});
